import styled from 'styled-components';


const SubHeaderWrapper = styled.div`
.steps-wrapper {
  width: 100%;
  padding: 30px 0;
  background-color: rgba(129, 139, 155, 0.1);
  margin-bottom: 2rem;
  .user-wrapper {
    display: inline-flex;
    align-items: center;
    p {
      margin: 0;
      font-size: 21px;
      color: #6B47F5;
      font-weight: bold;
      &.dark-color {
        color: #4c565c;
      }
    }
    .logo-wrapper {
      background: #6B47F5;
      width: 50px;
      height: 50px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .user-details {
      margin: 0 1rem;
      text-align: initial;
    }
  }

  .stepper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(110, 159, 187, 0.2);
    height: 40px;
    border-radius: 20px;
    .step {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 40px;
      border: 1px solid #6B47F5;
      background: #fff;
      color: #818b9b;
      border-radius: 50%;
      &.active {
        background: #34a853;
        color: #fff;
      }
      &.next {
        background: #6B47F5;
        color: #fff;
      }
    }
    &.titles {
      background: transparent;
    }
    .title {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      min-width: 50px;
      color: #818b9b;
      &.active {
        color: #34a853;
      }
      &.next {
        color: #6B47F5;
      }
    }
  }

  &.ar{
    
  }
}

`;


export default SubHeaderWrapper;